<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <router-link :to="{ path: '/admin/user/comments' }">
          <Button icon="ios-arrow-back" size="small" class="mr20">返回</Button>
        </router-link>
        <span
          class="ivu-page-header-title mr20"
          text="查看"></span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="formInfo"
            :model='formInfo'
            label-position="right"
            :label-width="120"
            @submit.native.prevent>
        <FormItem label="发布人：" prop="username">
          <Input
            v-model="formInfo.username"
            :maxlength='100'
            readonly
            class="perW50"
          />
        </FormItem>
        <FormItem label="阅读/导读：" prop="type">
          <Input
            v-model="formInfo.type"
            :maxlength='100'
            readonly
            class="perW50"
          />
        </FormItem>
        <FormItem label="心得：" prop="comments">
          <Input
            v-model="formInfo.comments"
            :maxlength='100'
            readonly
            type="textarea"
            class="perW50"
          />
        </FormItem>
        <FormItem label="点赞：" prop="like">
          <Input
            v-model="formInfo.like"
            :maxlength='100'
            readonly
            class="perW50"
          />
        </FormItem>
        <FormItem label="活动：" prop="activity_name">
          <Input
            v-model="formInfo.activity_name"
            :maxlength='100'
            readonly
            class="perW50"
          />
        </FormItem>
        <FormItem label="班级：" prop="className">
          <Input
            v-model="formInfo.className"
            :maxlength='100'
            readonly
            class="perW50"
          />
        </FormItem>
        <FormItem label="图片：" prop="pics">
            <img :src="item" v-for="(item, index) in formInfo.pics" style="width: 100px;margin-left: 10px">
        </FormItem>
        <FormItem label="视频：" prop="video">
          <video :src="formInfo.video" controls style="width: 500px" v-if="formInfo.video != ''"></video>
        </FormItem>

      </Form>
    </card>

  </div>

</template>
<script>
  import {comments} from '@/api/comments'

  export default {
    name: 'infoEdit',
    data() {
      return {
        loading: false,
        formInfo: {},
      }
    },
    created() {
      if (this.$route.params.id !== '0' && this.$route.params.id) {
        this.getInfo(this.$route.params.id)
      }
    },
    methods: {
      // 编辑加载数据
      getInfo(id) {
        comments(id).then(res => {
          console.log(res)
          this.formInfo = res.data
        }).catch(res => {
          this.$Message.error(res.msg)
        })
      }
    }

  }
</script>
